export enum DayOfWeekNames {
    SUNDAY = 'SUNDAY',
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
}

export type DayofWeekIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export function dayOfWeekToIndex(dayOfWeek: DayOfWeekNames): DayofWeekIndex {
    const nameToIndexMap: Record<DayOfWeekNames, DayofWeekIndex> = {
        SUNDAY: 0,
        MONDAY: 1,
        TUESDAY: 2,
        WEDNESDAY: 3,
        THURSDAY: 4,
        FRIDAY: 5,
        SATURDAY: 6,
    };
    return nameToIndexMap[dayOfWeek];
}

export interface IDateWindowInput {
    startDate: string;
    endDate: string;
}

export interface ITimeWindowInput {
    startDatetime: Date;
    endDatetime: Date;
}

export interface IOptionalTimeWindow {
    startDatetime: Date | null;
    endDatetime: Date | null;
    asDateWindow: IOptionalDateWindow | null;
}

export interface IOptionalTimeWindowInput {
    startDatetime: Date | null;
    endDatetime: Date | null;
}

export interface IDateWindowInput {
    startDate: string;
    endDate: string;
}

export interface IOptionalDateWindow {
    startDate: Date | null;
    endDate: Date | null;
}

export interface IOptionalDateWindowInput {
    startDate: string | null;
    endDate: string | null;
}
